module.exports = __webpack_public_path__ + "img/modal_next.b7087d40.png";